import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const ArrowRightIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M8.5 12L12.5 8L8.5 4' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <line x1='10.5' y1='8' x2='3.5' y2='8' stroke={color} strokeWidth='2' strokeLinecap='round' />
  </svg>
)

export default ArrowRightIcon
